import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Cookie } from "lucide-react";
import { getConsent, setConsent, pixelConfigured } from "@/lib/track";

export function CookieBanner() {
  const [show, setShow] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    if (getConsent()) return;
    pixelConfigured.then((on) => on && setShow(true));
  }, []);

  if (!show || pathname.startsWith("/admin")) return null;
  const choose = (yes) => {
    setConsent(yes);
    setShow(false);
  };

  return (
    <div className="fixed inset-x-0 top-0 z-[110] flex justify-center p-2" style={{ paddingTop: "max(0.5rem, env(safe-area-inset-top))" }} data-testid="cookie-banner">
      <div className="flex w-full max-w-[430px] items-center gap-2 rounded-2xl border border-[#27272A] bg-[#121215]/95 py-2 pl-3 pr-2 shadow-2xl backdrop-blur-xl">
        <Cookie size={16} className="shrink-0 text-[#D4AF37]" />
        <p className="flex-1 text-[12.5px] leading-snug text-[#D4D4D8]">Cookie di Meta per misurare le campagne?</p>
        <button onClick={() => choose(false)} data-testid="cookie-reject-button" className="rounded-full border border-[#3F3F46] px-3 py-1.5 text-[12.5px] font-semibold text-[#E4E4E7]">No</button>
        <button onClick={() => choose(true)} data-testid="cookie-accept-button" className="btn-gold rounded-full px-3 py-1.5 text-[12.5px] font-semibold">Accetta</button>
      </div>
    </div>
  );
}
